// extracted by mini-css-extract-plugin
module.exports = {"content":"RTE-content-vbwj2 htmlContent-root-1db2D typography-bodyCopy-3JspD","toolbar":"RTE-toolbar-3drmR","placeholder":"RTE-placeholder-5COCg typography-placeholder-GuRWD"};